import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";

import { CalendarClock } from "lucide-react";
import { useEffect, useState } from "react";
import { getAllEvents } from "../../API/Events/eventService";
const EventsList = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const fetchData = async () => {
    const response = await getAllEvents();
    setEvents(response?.events);
  };
  useEffect(() => {
    fetchData();
  }, []);

  const monthAbbreviations: { [key: number]: string } = {
    1: "janv.",
    2: "fév.",
    3: "mars",
    4: "avr.",
    5: "mai",
    6: "juin",
    7: "juil.",
    8: "août",
    9: "sept.",
    10: "oct.",
    11: "nov.",
    12: "déc.",
  };
  return (
    <>
      <div className="mb-10 ">
        <section className="p-32 text-center bg-bg_aquavesc bg-blend-overlay ">
          <div className="flex items-center justify-center">
            <CalendarClock className="w-16 h-16 mr-5 text-aquaFoncé" />
            <div className="font-bold text-center text-black text-7xl">
              Événements
            </div>
          </div>
        </section>

        <div className="container mx-auto mt-20 mb-20 md:px-72 sm:px-72">
          {events.map((event: any) => (
            <div key={event.id}>
              <hr className="w-full h-1 bg-primary" />
              <Link to={`/evenements/${event.slug}`}>
                <div className="flex justify-start mt-10 mb-20 space-x-10 ">
                  <div className="w-1/6 ">
                    {/* <h1 className="text-4xl font-bold text-center text-black">
              {new Date(event.date).getDate()}
            </h1>
            <h1 className="text-4xl font-bold text-center text-black">
              {new Date(event.date).getMonth()}
            </h1>
            <h1 className="text-4xl font-bold text-center text-black">
              {new Date(event.date).getFullYear()}
            </h1> */}
                    <div
                      className={` w-[70px] h-[94px] top-[30px] left-[30px]  bg-[url(src/images/vectorHover.svg)]`}
                    >
                      <div className="relative w-full h-[37px] top-[21px] left-[21px] flex justify-center">
                        <div className="absolute top-0 left-0  font-bold text-white text-[26px] tracking-[0] leading-[normal] whitespace-nowrap">
                          {/* {new Date(event.date).getDay()} */}
                          {new Date(event.date).toLocaleDateString("fr-FR", {
                            day: "numeric",
                          })}
                        </div>
                        <div className="absolute top-[27px]  -left-[1px]   font-medium text-white-color01 text-sm tracking-[0] leading-[normal] whitespace-nowrap text-white">
                          {
                            monthAbbreviations[
                              new Date(event.date).getMonth() + 1
                            ]
                          }
                        </div>
                        <div className="absolute top-[47px] -left-[2px]   font-medium text-white   text-sm tracking-[0] leading-[normal] whitespace-nowrap">
                          {new Date(event.date).toLocaleDateString("fr-FR", {
                            year: "numeric",
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <h1 className="mb-3 text-3xl text-black">{event.title}</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: event.description.replace(/<img[^>]*>/g, ""),
                      }}
                    />
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
        <div className="flex justify-center">
          <Button className="w-full md:w-1/6"> Voir plus</Button>
        </div>
      </div>
    </>
  );
};

export default EventsList;
